/**
 * Basically an immutable splice operation that replaces an index with an item
 */
export const replaceAt = <Item>(
  items: Array<Item>,
  index: number,
  item: Item
): Array<Item> => [...items.slice(0, index), item, ...items.slice(index + 1)];
